/* Package JSON Import will be here */
import React, { Suspense, lazy } from "react";
import { Route } from "react-router-dom";
/* Package JSON Import will be here */

/* Project Import will be here */
import { appRoutesConst } from "app/navigation";
import SpinnerAppLoading from "components/reusable/SpinnerAppLoading";
const Profile = lazy(() => import("pages/Profile"));
const ChangeMobileNumber = lazy(() => import("pages/Settings/ChangeMobileNumber"));
const Settings = lazy(() => import("pages/Settings/Settings"));
const MyCart = lazy(() => import("pages/MyCart"));
const OrderHistory = lazy(() => import("pages/Order/OrderHistory"));
const ProductDetail = lazy(() => import("pages/ProductDetail"));
const ManageWholesaler = lazy(() => import("pages/ManageWholesaler"));
const Checkout = lazy(() => import("pages/Checkout"));
const OrderHistoryDetails = lazy(() => import("pages/Order/OrderHistoryDetails"));
const Products = lazy(() => import("pages/Products"));
const FavProducts = lazy(() => import("pages/Products/FavProducts"));
const Promotions = lazy(() => import("pages/Promotion/Promotions"));
const PromotionDetails = lazy(() => import("pages/Promotion/PromotionDetails"));
const Notification = lazy(() => import("pages/Notification"));
const ViewAllProducts = lazy(() => import("pages/Products/ViewAllProducts"));
const KpiDashboard = lazy(() => import("pages/Dashboard/KpiDashboard"));
const Home = lazy(() => import("pages/Home"));
const SalesReturn = lazy(() => import("pages/SalesReturn"));
const SalesReturnSummary = lazy(() => import("pages/SalesReturn/SalesReturnSummary"))
const SmartList = lazy(() => import("pages/SmartList/SmartListPage"));
const StoreDashboard = lazy(() => import("pages/Store/StoreDashboard"));
const Consumers = lazy(() => import("pages/Consumers/index"));
const StoreProducts = lazy(() => import("pages/StoreProducts/index"));
const StoreDisplay = lazy(() => import("pages/StoreDisplay/index"));
const MyPayment = lazy(() => import("pages/Payment/Payments"));
const PaymentDetails = lazy(() => import("pages/Payment/PaymentDetails"));
const PaymentResponse = lazy(() => import("pages/Payment/PaymentResponse"));
const DigitalContent = lazy(() => import("pages/DigitalContent"));
const MyComplaints = lazy(() => import("pages/Complaints/MyComplaints"));
const OrderStatusDelivery = lazy(() => import("pages/Order/OrderStatusDelivery"));
const SalesReturnHistory = lazy(() => import("pages/SalesReturn/SalesReturnHistory"));
const SalesReturnHistoryDetails = lazy(() => import("pages/SalesReturn/SalesReturnHistoryDetails"));
const RetailerLedger = lazy(() => import("pages/reports/RetailerLedger"));
const QpsSchemes = lazy(() => import("pages/Promotion/QpsSchemes"));
const ExchangeReturn = lazy(() => import("pages/Exchange/exchangeReturn"));
const ExchangeReturnResult = lazy(() => import("pages/Exchange/exchangeReturnResult"));
const CancelOrder = lazy(() => import("pages/Order/CancelOrder"));
const SupportHelpline = lazy(() => import("pages/Common/SupportHelpline"));
const MyRewards = lazy(() => import("pages/rewards/MyRewards"));
const RewardHistory = lazy(() => import("pages/rewards/RewardHistory"));
const RewardsHistoryDetails = lazy(() => import("pages/rewards/RewardsHistoryDetails"));
const AppGuidance = lazy(() => import("pages/AppGuidance/AppGuidance"));
const ResetPasswordPage = lazy(() => import("pages/Settings/ResetPasswordPage"));
const MyEarningsLedgerPage = lazy(() => import("pages/RBP/earningsLedger/MyEarningsLedgerPage"));
const ClubEnrollmentPage = lazy(() => import("pages/RBP/enrollment/ClubEnrollmentPage"));
const SurveyPage = lazy(() => import("pages/Survey/SurveyPage"));
const SuggestedProductsPage = lazy(() => import("pages/Products/SuggestedProductsPage"));
const RepeatMyLastOrderPage = lazy(() => import("pages/Products/RepeatMyLastOrderPage"));
/* Project Import will be here */

const router = ({ match }) => (
  <Suspense fallback={<SpinnerAppLoading />}>
    <Route
      path={`${appRoutesConst.productDetail}/:productId`}
      component={ProductDetail}
    />

    <Route
      exact
      path={appRoutesConst.home}
      component={Home}
    />

    <Route
      exact
      path={appRoutesConst.productList}
      component={Products}
    />

    <Route
      exact
      path={appRoutesConst.smartList}
      component={SmartList}
    />

    <Route
      path={appRoutesConst.profile}
      component={Profile}
    />

    <Route
      path={appRoutesConst.changeMobileNumber}
      component={ChangeMobileNumber}
    />

    <Route
      path={appRoutesConst.resetPassword}
      component={ResetPasswordPage}
    />

    <Route
      path={appRoutesConst.settings}
      component={Settings}
    />
    <Route
      exact
      path={`${appRoutesConst.orderHistoryDetails}/:orderId`}
      component={OrderHistoryDetails}
    />

    <Route
      path={`${appRoutesConst.products}/:category?/:subcategory?`}
      component={Products}
    />

    <Route
      path={appRoutesConst.orderSummary}
      component={MyCart}
    />

    <Route
      path={appRoutesConst.checkout}
      component={Checkout}
    />

    <Route
      exact
      path={appRoutesConst.orderHistory}
      component={OrderHistory}
    />

    <Route
      path={`${appRoutesConst.manageWholesalers}/:redirectToCode?`}
      component={ManageWholesaler}
    />

    <Route
      path={appRoutesConst.favProducts}
      component={FavProducts}
    />

    <Route
      path={appRoutesConst.promotions}
      component={Promotions}
    />

    <Route
      path={`${appRoutesConst.promotionDetails}/:schemeId`}
      component={PromotionDetails}
    />

    <Route
      path={appRoutesConst.notification}
      component={Notification}
    />

    <Route
      path={appRoutesConst.digitalContent}
      component={DigitalContent}
    />

    <Route
      path={appRoutesConst.myComplaints}
      component={MyComplaints}
    />

    <Route
      path={`${appRoutesConst.viewAllProducts}/:viewAllType`}
      component={ViewAllProducts}
    />

    <Route
      path={appRoutesConst.kpiDashboard}
      component={KpiDashboard}
    />

    <Route
      path={appRoutesConst.salesReturn}
      component={SalesReturn}
    />

    <Route
      path={appRoutesConst.salesReturnSummary}
      component={SalesReturnSummary}
    />

    <Route
      path={`${appRoutesConst.salesReturnProducts}/:category?/:subcategory?`}
      component={SalesReturn}
    />

    <Route
      path={appRoutesConst.storeDashboard}
      component={StoreDashboard}
    />

    <Route
      path={appRoutesConst.consumer}
      component={Consumers}
    />

    <Route
      path={appRoutesConst.storeProducts}
      component={StoreProducts}
    />

    <Route
      path={appRoutesConst.storeDisplay}
      component={StoreDisplay}
    />

    <Route
      path={appRoutesConst.myPayment}
      component={MyPayment}
    />

    <Route
      path={appRoutesConst.paymentDetails}
      component={PaymentDetails}
    />

    <Route
      path={appRoutesConst.paymentResponse}
      component={PaymentResponse}
    />

    <Route
      path={appRoutesConst.orderStatusDelivery}
      component={OrderStatusDelivery}
    />

    <Route
      path={appRoutesConst.salesReturnHistory}
      component={SalesReturnHistory}
    />

    <Route
      path={`${appRoutesConst.salesReturnHistoryDetails}/:returnId`}
      component={SalesReturnHistoryDetails}
    />

    <Route
      path={appRoutesConst.retailerLedger}
      component={RetailerLedger}
    />

    <Route
      path={appRoutesConst.qpsSchemes}
      component={QpsSchemes}
    />

    <Route
      exact
      path={appRoutesConst.exchangeReturn}
      component={ExchangeReturn}
    />

    <Route
      path={`${appRoutesConst.exchangeReturnResult}/:exchangeOrderId/:exchangeOrderNumber/:exchangeReturnId/:exchangeReturnNumber`}
      component={ExchangeReturnResult}
    />

    <Route
      exact
      path={appRoutesConst.cancelOrder}
      component={CancelOrder}
    />

    <Route
      path={appRoutesConst.supportHelpline}
      component={SupportHelpline}
    />

    <Route
      path={appRoutesConst.myRewards}
      component={MyRewards}
    />

    <Route
      path={`${appRoutesConst.rewardsHistoryDetails}/:redemptionId`}
      component={RewardsHistoryDetails}
    />

    <Route
      path={appRoutesConst.rewardHistory}
      component={RewardHistory}
    />

    <Route
      path={appRoutesConst.myEarningsLedger}
      component={MyEarningsLedgerPage}
    />

    <Route
      path={appRoutesConst.clubEnrollment}
      component={ClubEnrollmentPage}
    />

    <Route
      exact
      path={appRoutesConst.appGuidance}
      component={AppGuidance}
    />

    <Route
      path={appRoutesConst.survey}
      component={SurveyPage}
    />

    <Route
      path={appRoutesConst.suggestedProducts}
      component={SuggestedProductsPage}
    />

    <Route
      path={appRoutesConst.repeatMyLastOrder}
      component={RepeatMyLastOrderPage}
    />
  </Suspense>
);

export default router;